import { render, staticRenderFns } from "./OptionListTable.vue?vue&type=template&id=12404e52"
import script from "./OptionListTable.vue?vue&type=script&lang=js"
export * from "./OptionListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports